import axios from 'axios'

export default {
  sendMessage: (data) => axios.post(`/api/v1/messages`, data)
}
